import { render, staticRenderFns } from "./AccountManageThumb.vue?vue&type=template&id=a86c5c98&"
import script from "./AccountManageThumb.vue?vue&type=script&lang=ts&"
export * from "./AccountManageThumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports